import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import { IconExternalLink } from "@tabler/icons-react";
import ComingSoonImg from "../assets/imgs/coming_soon.png";
import Logo from "../assets/imgs/sm-logo.png";

// Where the "Learn more" button sends people while swap is paused.
const LEARN_MORE_URL = "https://xrphtoken.com";

const BRAND_GRADIENT =
  "linear-gradient(90deg, #03F982 -7.95%, #37C3A6 20.29%, #8572DB 61.19%, #AF45EE 115.47%)";

function ComingSoon() {
  return (
    <Box position="relative" minH="100vh" bg="#08090C" overflow="hidden">
      {/* ambient glows */}
      <Box
        position="absolute"
        bottom="-180px"
        left="-160px"
        w="620px"
        h="620px"
        borderRadius="50%"
        bg="radial-gradient(circle, rgba(55,195,166,0.20) 0%, rgba(55,195,166,0) 70%)"
        pointerEvents="none"
      />
      <Box
        position="absolute"
        top="-220px"
        right="-140px"
        w="680px"
        h="680px"
        borderRadius="50%"
        bg="radial-gradient(circle, rgba(175,69,238,0.22) 0%, rgba(175,69,238,0) 70%)"
        pointerEvents="none"
      />
      {/* faint grid */}
      <Box
        position="absolute"
        inset="0"
        pointerEvents="none"
        opacity="0.35"
        backgroundImage="linear-gradient(rgba(255,255,255,0.028) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.028) 1px, transparent 1px)"
        backgroundSize="64px 64px"
      />

      <Box position="relative" zIndex="1">
        <Flex align="center" gap="8px" pt="24px" px={{ base: "20px", md: "48px" }}>
          <Image src={Logo} alt="XRPH Swap" height="42px" width="42px" />
          <Text color="#fff" fontWeight="700" fontSize="24px">
            XRPH
          </Text>
          <Text color="#fff" fontWeight="300" fontSize="24px">
            Swap
          </Text>
        </Flex>

        <Flex
          justify="center"
          align="center"
          px={{ base: "16px", md: "24px" }}
          py={{ base: "40px", md: "64px" }}
        >
          <Box
            w="100%"
            maxW="730px"
            bg="#101317"
            border="1px solid #23272E"
            borderRadius="20px"
            px={{ base: "20px", md: "48px" }}
            py={{ base: "32px", md: "44px" }}
            textAlign="center"
            boxShadow="0 24px 80px rgba(0,0,0,0.45)"
          >
          
            <Text
              as="h1"
              fontSize={{ base: "30px", md: "44px" }}
              fontWeight="700"
              lineHeight="1.15"
              color="#fff"
              mb="14px"
            >
              <Box
                as="span"
                bgGradient="linear(to-r, #37C3A6, #8572DB, #AF45EE)"
                bgClip="text"
              >
                XRPH Swap
              </Box>{" "}
              is coming soon
            </Text>

            <Text
              fontSize={{ base: "15px", md: "18px" }}
              color="#9AA4B2"
              maxW="480px"
              mx="auto"
              mb={{ base: "24px", md: "32px" }}
            >
              We&apos;re preparing a faster and smarter swap experience for you.
            </Text>

            <Flex justify="center" mb={{ base: "28px", md: "36px" }}>
              <Image
                src={ComingSoonImg}
                alt="A person at a desk watching the XRPH Swap launch screen"
                w="100%"
                maxW="520px"
                h="auto"
              />
            </Flex>

          </Box>
        </Flex>
      </Box>
    </Box>
  );
}

export default ComingSoon;
